import { lazy, Component, FunctionComponent, ComponentProps, LazyExoticComponent } from 'react';

const EditPhonecall = lazy(() => import('Components/EditPhonecall'));
const EditTodo = lazy(() => import('Components/EditTodo'));
const EditCallListDrawer = lazy(() => import('App/components/drawers/EditCallListDrawer'));
const ExportDataReact = lazy(() => import('App/components/ExportDataReact/ExportDataReact'));
const EditColumnsModal = lazy(() => import('App/components/EditColumnsModal'));
const EditGuestListColumnsModal = lazy(() => import('App/babel/components/SocialEvent/EditGuestListColumnsModal'));
const CreateTodo = lazy(() => import('Components/CreateTodo'));
const CreateCall = lazy(() => import('Components/CreateCall'));
const PlanPhonecallsAction = lazy(() => import('Components/PlanPhonecallsAction'));
const PlanPhonecallsMulti = lazy(() => import('Components/PlanPhonecallsMulti'));
const CreateTodosMulti = lazy(() => import('Components/CreateTodosMulti'));
const AdditionalBoardMembers = lazy(() => import('Components/AdditionalBoardMembers'));
const UtmLinkGenerator = lazy(() => import('Components/UtmLinkGenerator'));
const EditSocialEventAddContacts = lazy(() => import('Components/SocialEvent/EditSocialEventAddContacts'));
const GoalSummaryDrawer = lazy(() => import('Components/GoalSummaryDrawer'));
const NotificationDropdown = lazy(() => import('Components/NotificationDropdown'));
const PlanPhonecallsTriggerAction = lazy(() => import('Components/PlanPhonecallsTriggerAction'));
const CreateTodoTriggerAction = lazy(() => import('Components/CreateTodoTriggerAction'));
const MergeContacts = lazy(() => import('App/components/MergeContacts'));
const ReportcenterDrilldownDrawer = lazy(() => import('App/pages/Reportcenter/ReportcenterDrilldownDrawer'));
const ListDrawer = lazy(() => import('Components/ListDrawer/ListDrawer'));
const NotificationDetailModal = lazy(() => import('App/components/NotificationDetailModal'));
const ContactScraperModal = lazy(() => import('App/components/ContactScraper/ContactScraperModal'));
const ContactScraperConfirmModal = lazy(() => import('App/components/ContactScraper/ContactScraperConfirmModal'));
const ConfirmBuyProspectModal = lazy(() => import('App/components/ConfirmBuyProspect/ConfirmBuyProspectModal'));
const ApiKey = lazy(() => import('App/components/ApiKey'));
const MergeWithBoardmemberModal = lazy(() =>
	import('Components/MergeWithBoardmember').then(m => ({
		default: m.MergeWithBoardmemberModal
	}))
);
const CompetitorDrawer = lazy(() => import('App/pages/Admin/CompetitorDrawer'));
const SessionExpireWarning = lazy(() => import('Components/Modals/SessionExpireWarning'));
const EditClient = lazy(() => import('App/components/EditClient'));
const EditContact = lazy(() => import('App/components/EditContact'));
const EditDynamicLink = lazy(() => import('App/components/EditDynamicLink'));
const EditPromptModal = lazy(() => import('App/pages/Admin/subPages/AdminAIPrompts/EditPromptModal'));
const AccountDeactivationModal = lazy(() => import('App/babel/components/Account/AccountDeactivationModal'));
const SentMail = lazy(() => import('Components/MailDrawers/SentMail'));
const NewSingleMail = lazy(() => import('Components/MailDrawers/NewSingleMail'));
const AddLabelsMulti = lazy(() => import('Components/Modals/AddLabelsMulti'));
const AcceptTerms = lazy(() => import('App/components/AcceptTerms'));
const SendWebhook = lazy(() => import('App/components/SendWebhook'));
const RequestSupport = lazy(() => import('App/components/RequestSupport'));
const CreateFlow = lazy(() => import('App/components/CreateFlow'));
const CreateFormReact = lazy(() =>
	import('Components/CreateForm/CreateForm').then(m => ({
		default: m.CreateFormReact as FunctionComponent<{ formType?: string }>
	}))
);
const CreateTemplateFlow = lazy(() => import('App/components/CreateTemplateFlow'));
const SubscriptionPreview = lazy(() => import('App/components/SubscriptionPreview'));
const CreateSubscription = lazy(() =>
	import('App/components/EditSubscription').then(m => ({
		default: m.CreateSubscription
	}))
);
const EditSubscription = lazy(() =>
	import('App/components/EditSubscription').then(m => ({
		default: m.EditSubscription
	}))
);
const MoveSubscription = lazy(() => import('App/components/MoveSubscription'));
const FlowLoopSettings = lazy(() => import('App/components/FlowLoopSettings'));
const DeleteForbiddenAlert = lazy(() => import('App/components/DeleteForbiddenAlert'));
const LandingpageEditorModal = lazy(() =>
	import('App/components/LandingpageEditor/LandingpageEditor').then(m => ({
		default: m.LandingpageEditorModal
	}))
);
const LeadDrawer = lazy(() => import('Components/LeadDrawer'));
const VisitDrawer = lazy(() => import('Components/VisitDrawer'));
const AssignModalReact = lazy(() =>
	import('Components/AssignModal/AssignModal').then(m => ({
		default: m.AssignModalReact
	}))
);
const ForecastingDrawer = lazy(() => import('App/components/Forecasting'));
const CleanMyData = lazy(() => import('App/components/CleanMyData'));
const HandleDuplicates = lazy(() => import('App/components/HandleDuplicates'));
const MailPreview = lazy(() => import('App/components/MailPreview'));
const MaxCeilingReachedOnSeatsReact = lazy(() =>
	import('Components/MaxCeilingReachedOnSeats/MaxCeilingReachedOnSeats').then(m => ({
		default: m.MaxCeilingReachedOnSeatsReact
	}))
);
const ChooseMailIntegrationModal = lazy(() =>
	import('Components/Modals/ChooseMailIntegration').then(m => ({
		default: m.ChooseMailIntegrationModal
	}))
);
const WonOpportunityWithSubs = lazy(() => import('App/components/WonOpportunityWithSubs'));
const PriceListDrawer = lazy(() => import('App/components/PriceListDrawer'));
const ProductBundleDrawer = lazy(() => import('App/components/ProductBundleDrawer'));
const CreateAccount = lazy(() => import('App/pages/CreateAccount'));
const EditProductBundleOrder = lazy(() => import('App/components/EditProductBundleOrder'));
const NewMarketEvent = lazy(() => import('App/components/NewMarketEvent'));
const EditClientTarget = lazy(() => import('App/components/EditClientTarget'));
const ARRChangeDrawerV2 = lazy(() => import('App/components/ARRChangeDrawerV2'));
const CreateTodosAction = lazy(() => import('App/components/CreateTodosAction'));
const FormActionCondition = lazy(
	() => import('App/babel/components/FormEditor/SettingsTab/FormActions/FormActionConditionEditor')
);
const ProductSearch = lazy(() => import('Components/ProductSearch'));
const ReportcenterTV = lazy(() => import('App/pages/Reportcenter/ReportcenterTV'));
const FindSocialEventModal = lazy(() => import('App/components/FindSocialEventModal'));
const FindClientModal = lazy(() => import('App/components/FindClientModal'));
const FindFormModal = lazy(() => import('App/components/FindFormModal'));
const EditFormSubmitModal = lazy(() => import('App/components/EditFormSubmitModal/EditFormSubmitModal'));
const FindContactModal = lazy(() => import('App/components/FindContactModal'));
const SignalsNews = lazy(() => import('App/components/SignalsNews'));
const RisksCompanyGroup = lazy(() => import('App/components/RisksCompanyGroup'));
const UpsellCompanyGroup = lazy(() => import('App/components/UpsellCompanyGroup'));
const ReportcenterTVSettings = lazy(() => import('App/pages/Reportcenter/ReportcenterTV/ReportcenterTVSettings'));
const ReportcenterTVPublicDisplayConnect = lazy(
	() => import('App/pages/Reportcenter/ReportcenterTV/ReportcenterTVPublicDisplayConnect')
);
const EditProductCategory = lazy(() => import('App/components/EditProductCategory'));
const CopySocialEvent = lazy(() => import('Components/SocialEvent/CopySocialEvent'));
const Alert = lazy(() => import('App/components/Alerts').then(m => ({ default: m.default })));
const UnsavedChangesAlert = lazy(() => import('App/components/Alerts').then(m => ({ default: m.UnsavedChangesAlert })));
const SaveChangesAlert = lazy(() => import('App/components/Alerts').then(m => ({ default: m.SaveChangesAlert })));
const RemoveAlert = lazy(() => import('App/components/Alerts').then(m => ({ default: m.RemoveAlert })));
const EditMailSignatureRoot = lazy(() => import('Components/MailSignature/EditMailSignatureModal'));
const CreateUpsalesAccount = lazy(() => import('Components/CreateAccount'));
const CreateAppointmentAction = lazy(() => import('App/components/CreateAppointmentAction'));
const RefreshAccount = lazy(() => import('Components/Modals/RefreshAccount/RefreshAccount'));
const EditSocialEventAddResource = lazy(() => import('App/babel/components/SocialEvent/EditSocialEventAddResource'));
const FullTermsModal = lazy(() => import('App/babel/components/Modals/FullTermsModal'));
const AnonFieldPage = lazy(() => import('App/babel/components/anonymization/fieldPage/fieldPage'));
const MultiUpdateActivity = lazy(
	() => import('App/components/MultiActionModal/MultiUpdateActivity/MultiUpdateActivity')
);
const MultiUpdateClient = lazy(() => import('App/components/MultiActionModal/MultiUpdateClient/MultiUpdateClient'));
const MultiCloseActivityModal = lazy(
	() => import('App/components/MultiActionModal/MultiCloseActivity/MultiCloseActivity')
);
const AskForInput = lazy(() => import('App/components/Alerts/AskForInput/AskForInput'));
const MatchCompaniesBeforeMerge = lazy(() => import('App/components/MatchCompaniesBeforeMerge'));
const DuplicateIntroModal = lazy(() => import('App/components/DuplicateIntroModal'));
const AddToSegmentModal = lazy(() =>
	import('Components/addToSegmentModal/addToSegmentModal').then(m => ({
		default: m.AddToSegmentModal
	}))
);
const TemplateEditorModal = lazy(() =>
	import('Components/Admin/DocumentTemplate/TemplateEditor').then(m => ({
		default: m.TemplateEditorModal
	}))
);
const InactivateContacts = lazy(() => import('App/components/CleanMyData/InactivateContacts/InactivateContacts'));
const EditTicketResponseTemplate = lazy(() => import('Components/EditTicketResponseTemplate'));
const EditTicketAutoReplyTemplate = lazy(
	() => import('Components/EditTicketAutoReplyTemplate/EditTicketAutoReplyTemplate')
);
const RiskDrawer = lazy(() => import('App/components/RiskDrawer'));
const EditOrder = lazy(() => import('App/components/EditOrder'));
const OpenTicket = lazy(() => import('App/components/EditTicket'));
const VerifyTimeframeModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/VerifyTimeframe/VerifyTimeframe').then(
		m => ({ default: m.VerifyTimeframeModal })
	)
);
const EditProjectPlanTemplate = lazy(
	() => import('Components/Admin/ProjectPlanTemplate/Modals/EditProjectPlanTemplate/EditProjectPlanTemplate')
);
const EditTaskTemplate = lazy(() => import('Components/Admin/ProjectPlanTemplate/Modals/EditTaskTemplate'));
const EditEventDomainModal = lazy(() =>
	import('Components/Admin/EditEventDomain').then(m => ({
		default: m.EditEventDomainModal
	}))
);
const ImageUrlModal = lazy(() => import('Components/ImageUrl').then(m => ({ default: m.ImageUrlModal })));
const EditProjectPlan = lazy(() => import('Components/EditProjectPlan'));
const EditProjectPlanType = lazy(
	() => import('Components/Admin/ProjectPlanWorkProcess/ProjectPlanType/EditProjectPlanType')
);
const CreateRelation = lazy(() => import('Components/CreateRelation'));
const ViewTickets = lazy(() => import('App/components/ViewTickets'));
const OptIn = lazy(() => import('App/components/OptIn/OptIn'));
const SubaccountDrawer = lazy(() => import('Components/SubaccountDrawer/SubaccountDrawer'));
const IndustryInsightsDrawer = lazy(() => import('Components/IndustryInsights/IndustryInsightsDrawer'));
const AgreementFulfillmentModal = lazy(() => import('App/components/AgreementFulfillmentModal'));
const LostOpportunityModal = lazy(() => import('App/components/LostOpportunity/LostOpportunityModal'));
const ListModal = lazy(() => import('App/components/List/List'));
const UploadFileModal = lazy(() => import('App/components/UploadFileModal'));
const SelectFieldModal = lazy(() => import('App/components/SelectFieldModal'));
const EditNote = lazy(() => import('Components/Modals/EditNote'));
const MoveOrCloseActivity = lazy(() => import('App/components/MoveOrCloseActivity/MoveOrCloseActivity'));
const MoveContactModal = lazy(() => import('App/components/MoveContactModal/MoveContactModal'));
const ConfirmBuyProspectsModal = lazy(() => import('App/components/ConfirmBuyProspects/ConfirmBuyProspectsModal'));
const CreateGroupMail = lazy(() =>
	import('App/babel/components/CreateGroupMail/CreateGroupMail').then(m => ({
		default: m.CreateGroupMailReact
	}))
);
const StageListModal = lazy(() => import('App/components/StageListModal/StageListModal'));
const CreateDocumentModal = lazy(() => import('App/components/CreateDocument/CreateDocumentModal'));
const PdfGeneric = lazy(() => import('Components/CreateAccount/PdfGeneric'));
const PreviewPdfModal = lazy(() =>
	import('Components/Admin/DocumentTemplate/PreviewPdf/PreviewPdf').then(m => ({
		default: m.PreviewPdfModal
	}))
);
const ConfirmEsignModal = lazy(() => import('App/components/Esign/ConfirmEsign/ConfirmEsign'));
const SalesCoachModalReact = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/SalesCoachModal').then(m => ({
		default: m.SalesCoachModalReact
	}))
);
const AccountRelationModal = lazy(() =>
	import('Components/Account/AccountRelationModal/AccountRelationModal').then(m => ({
		default: m.AccountRelationModal
	}))
);
const AssignModalLead = lazy(() =>
	import('Components/AssignModal/AssignModalLead').then(m => ({
		default: m.AssignModalLead
	}))
);
const CreateActivityModal = lazy(() =>
	import('Components/Modals/CreateActivity/CreateActivity').then(m => ({
		default: m.CreateActivityModal
	}))
);
const OptOutModal = lazy(() => import('Components/Admin/OptOutModal').then(m => ({ default: m.OptOutModal })));
const WonOpportunityModal = lazy(() =>
	import('App/components/WonOpportunity/WonOpportunity').then(m => ({
		default: m.WonOpportunityModal
	}))
);
const YourYearWithUpsalesModal = lazy(() =>
	import('Components/YourYearWithUpsales/YourYearWithUpsales').then(m => ({
		default: m.YourYearWithUpsalesModal
	}))
);
const InsertTag = lazy(() => import('App/components/InsertTag/InsertTag'));
const LandingPageSettings = lazy(() => import('Components/LandingpageSettings'));
const EditAppointment = lazy(() => import('Components/Modals/Appointment/EditAppointment'));
const FileBrowserModal = lazy(() => import('Components/FileBrowser').then(m => ({ default: m.FileBrowserModal })));
const EditProductModal = lazy(() =>
	import('Components/Modals/EditProduct/EditProductModal').then(m => ({
		default: m.EditProductModal
	}))
);
const OpenCallModal = lazy(() => import('App/components/OpenCallModal'));
const ClientListModal = lazy(() => import('App/components/ClientListModal/ClientListModal'));
const SharedViewsModal = lazy(() =>
	import('Components/Admin/SharedViews/SharedViewsModal').then(m => ({
		default: m.SharedViewsModal
	}))
);
const VerifyBudgetModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/VerifyBudget/VerifyBudget').then(m => ({
		default: m.VerifyBudgetModal
	}))
);
const SolutionModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/Solution/Solution').then(m => ({
		default: m.SolutionModal
	}))
);
const ToggleFiscalYearModalReact = lazy(() =>
	import('Components/Admin/ToggleFiscalYearModal/ToggleFiscalYearModal').then(m => ({
		default: m.ToggleFiscalYearModalReact
	}))
);
const CreateReportModal = lazy(() => import('Components/Insights/CreateReportModal'));
const MailTemplateBrowserModal = lazy(() =>
	import('App/components/MailTemplateBrowserModal/MailTemplateBrowserModal').then(m => ({
		default: m.MailTemplateBrowserModal
	}))
);
const MultiUpdateContact = lazy(() => import('App/components/MultiActionModal/MultiUpdateContact/MultiUpdateContact'));
const MultiUpdateOrder = lazy(() => import('App/components/MultiActionModal/MultiUpdateOrder/MultiUpdateOrder'));
const MultiUpdateTicket = lazy(() => import('App/components/MultiActionModal/MultiUpdateTicket/MultiUpdateTicket'));
const MultiUpdateProjectPlan = lazy(
	() => import('App/components/MultiActionModal/MultiUpdateProjectPlan/MultiUpdateProjectPlan')
);
const IntegrationModal = lazy(() => import('Components/IntegrationModal/IntegrationModal'));
const GenericModal = lazy(() => import('App/components/GenericModal/GenericModal'));
const EditRoleModal = lazy(() => import('App/components/EditRoleModal/EditRoleModal'));
const ConfirmLandingPageModal = lazy(() =>
	import('Components/Modals/ConfirmLandingPage').then(m => ({
		default: m.ConfirmLandingPageModal
	}))
);
const EditCustomFieldModal = lazy(() =>
	import('Components/Modals/Fields/EditCustomField').then(m => ({
		default: m.EditCustomFieldModal
	}))
);
const AppWidget = lazy(() => import('Components/Modals/AppWidgetModal/AppWidgetModal'));
const MultiUpdateAppointmentModal = lazy(
	() => import('App/components/MultiActionModal/MultiUpdateAppointment/MultiUpdateAppointment')
);
const SelectOpportunity = lazy(() => import('App/components/SelectOpportunity/SelectOpportunity'));
const DelayedPayment = lazy(() => import('App/components/DelayedPayment/DelayedPayment'));
const ResetScore = lazy(() => import('App/components/ResetScore/ResetScore'));
const ValidDomainModal = lazy(() => import('Components/ValidDomainModal/ValidDomainModal'));
const ExportContactDataModal = lazy(() => import('App/components/ExportContactDataModal/ExportContactDataModal'));
const EditStandardFieldModal = lazy(() =>
	import('Components/Admin/EditStandardFieldModal').then(m => ({
		default: m.EditStandardFieldModal
	}))
);
const UpdateClientDuns = lazy(() => import('App/components/UpdateClientDuns/UpdateClientDuns'));
const MergeClients = lazy(() => import('App/components/MergeClients'));
const Map = lazy(() => import('App/components/Map/MapModal'));
const ProjectMap = lazy(() => import('App/pages/Map/ProjectMap/ProjectMapModal'));
const EditDocumentTemplateModal = lazy(() => import('App/components/EditDocumentTemplate/EditDocumentTemplateModal'));
const ConfirmSoliditetUpdateModal = lazy(() => import('App/components/ConfirmSoliditetUpdateModal'));
const DownloadList = lazy(() => import('App/components/DownloadList/DownloadList'));
const TranslateFieldsModal = lazy(() =>
	import('App/babel/components/Admin/TranslateFieldModal').then(m => ({
		default: m.TranslateFieldsModal
	}))
);
const NewSegmentModal = lazy(() =>
	import('App/components/NewSegment/NewSegmentModal').then(m => ({
		default: m.NewSegmentModal
	}))
);
const SendEmailAction = lazy(() => import('App/components/SendEmailAction/SendEmailAction'));
const ConfirmParentProspecting = lazy(
	() => import('App/babel/components/Modals/ConfirmParentProspecting/ConfirmParentProspecting')
);
const NextStepModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/NextStep/NextStep').then(m => ({
		default: m.NextStepModal
	}))
);
const ChecklistItemModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/ChecklistItem/ChecklistItem').then(m => ({
		default: m.ChecklistItemModal
	}))
);
const EditCampaignModal = lazy(() => import('App/components/EditCampaign/EditCampaign'));
const DecisionMakersModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/DecisionMakers/DecisionMakers').then(m => ({
		default: m.DecisionMakersModal
	}))
);
const CreateActivityActionModal = lazy(
	() => import('App/components/MultiActionModal/CreateActivityAction/CreateActivityAction')
);
const DecisionMakersProModal = lazy(() =>
	import('Components/Admin/SalesProcess/SalesCoach/Modals/SalesCoachModal/DecisionMakersPro/DecisionMakersPro').then(
		m => ({ default: m.DecisionMakersProModal })
	)
);
const ConfirmSoliditetBuyParentModal = lazy(
	() => import('App/components/ConfirmSoliditetBuyParent/ConfirmSoliditetBuyParent')
);
const RequestTierUpgradeModal = lazy(() => import('App/components/RequestTierUpgradeModal'));
const CreateMailTemplateModal = lazy(() =>
	import('Components/CreateMailTemplate').then(m => ({
		default: m.CreateMailTemplateModal
	}))
);
const EditEsign = lazy(() => import('App/components/Esign/EditEsign/EditEsign').then(m => ({ default: m.EditEsign })));
const CustomerPortfolioPotentialDrawer = lazy(() => import('App/components/CustomerPortfolioPotentialDrawer'));
const CreateExternalContact = lazy(() => import('App/components/EditTicket/EditTicket/CreateExternalContact'));
const ForwardConversation = lazy(() => import('App/components/EditTicket/EditTicket/ForwardConversation'));
const ResetLeadMulti = lazy(() =>
	import('App/components/ResetLeadMulti/ResetLeadMulti').then(m => ({
		default: m.ResetLeadMulti
	}))
);
const RelationsSignalDrawer = lazy(
	() => import('App/components/RelationsSignalWidget/components/RelationsSignalDrawer/RelationsSignalDrawer')
);
const MergeTickets = lazy(() => import('App/components/MergeTickets'));
const ScrapeCompanyWebsites = lazy(() => import('App/components/ScrapeCompanyWebsites/index'));
const EditUDOModal = lazy(() => import('Components/Modals/EditUDO/EditUDO'));
const CdhTableRowDrawer = lazy(() => import('App/components/Billing/CdhTableRowDrawer/CdhTableRowDrawer'));
const DocumentTemplateCopyModal = lazy(
	() => import('App/babel/components/DocumentTemplateEditor/DocumentTemplateCopyModal')
);
export enum Animation {
	Fade = 'fade',
	SlideBottom = 'slide-bottom',
	DrawerRight = 'drawer-right',
	None = 'none'
}

export type ModalOpts = {
	closeOnCurtain?: boolean;
	animation?: Animation;
	drawer?: boolean;
	closeOnEscape?: boolean;
};

export type ModalConfigName =
	| 'LeadDrawer'
	| 'ApiKey'
	| 'VisitDrawer'
	| 'ForecastingDrawer'
	| 'EditPhonecall'
	| 'EditCallList'
	| 'ExportDataReact'
	| 'EditColumnsModal'
	| 'EditGuestListColumnsModal'
	| 'MultiUpdateActivity'
	| 'MultiUpdateClient'
	| 'MultiCloseActivityModal'
	| 'EditTodo'
	| 'CreateTodo'
	| 'CreateCall'
	| 'CreateTodosAction'
	| 'FormActionCondition'
	| 'PlanPhonecallsAction'
	| 'PlanPhonecallsMulti'
	| 'CreateTodosMulti'
	| 'AdditionalBoardMembers'
	| 'UtmLinkGenerator'
	| 'AddSocialEventContacts'
	| 'GoalSummaryDrawer'
	| 'NotificationDropdown'
	| 'PlanPhonecallsTriggerAction'
	| 'CreateTodoTriggerAction'
	| 'ReportcenterDrilldownDrawer'
	| 'ListDrawer'
	| 'MergeWithBoardmemberModal'
	| 'CompetitorDrawer'
	| 'SignalsNews'
	| 'RisksCompanyGroup'
	| 'UpsellCompanyGroup'
	| 'SessionExpireWarning'
	| 'EditClient'
	| 'EditContact'
	| 'AccountDeactivationModal'
	| 'SentMail'
	| 'NewSingleMail'
	| 'ChooseMailIntegration'
	| 'AddLabelsMulti'
	| 'AcceptTerms'
	| 'RequestSupport'
	| 'SendWebhook'
	| 'CreateFlow'
	| 'CreateForm'
	| 'CreateTemplateFlow'
	| 'EditDynamicLink'
	| 'SubscriptionPreview'
	| 'CreateSubscription'
	| 'EditSubscription'
	| 'MoveSubscription'
	| 'ConfirmBuyProspectModal'
	| 'FlowLoopSettings'
	| 'WonOpportunityWithSubs'
	| 'DeleteForbiddenAlert'
	| 'CleanMyData'
	| 'HandleDuplicates'
	| 'MailPreview'
	| 'MaxCeilingReachedOnSeats'
	| 'PriceListDrawer'
	| 'ProductBundleDrawer'
	| 'CreateAccount'
	| 'EditProductBundleOrder'
	| 'NewMarketEvent'
	| 'EditClientTarget'
	| 'NotificationDetail'
	| 'ContactScraperModal'
	| 'ContactScraperConfirmModal'
	| 'ARRChangeDrawerV2'
	| 'ProductSearch'
	| 'EditTicket'
	| 'CreateExternalContact'
	| 'ForwardConversation'
	| 'CopySocialEvent'
	| 'AssignModal'
	| 'ReportcenterTV'
	| 'FindSocialEvent'
	| 'FindClient'
	| 'FindForm'
	| 'EditFormSubmit'
	| 'FindContact'
	| 'ToggleFiscalYear'
	| 'MoveContact'
	| 'ReportcenterTVSettings'
	| 'ReportcenterTVPublicDisplayConnect'
	| 'EditProductCategory'
	| 'EditUDO'
	| 'Alert'
	| 'FullTerms'
	| 'UnsavedChangesAlert'
	| 'SaveChangesAlert'
	| 'RemoveAlert'
	| 'AskForInput'
	| 'MatchCompaniesBeforeMerge'
	| 'MergeContacts'
	| 'DuplicateIntroModal'
	| 'InactivateContacts'
	| 'EditMailSignature'
	| 'CreateUpsalesAccount'
	| 'CreateAppointmentAction'
	| 'RefreshAccount'
	| 'EditSocialEventAddResource'
	| 'RiskDrawer'
	| 'AnonFieldPage'
	| 'EditOrder'
	| 'AddToSegmentModal'
	| 'ViewTickets'
	| 'VerifyTimeframeModal'
	| 'EditTicketResponseTemplate'
	| 'EditTicketAutoReplyTemplate'
	| 'EditProjectPlanTemplate'
	| 'EditTaskTemplate'
	| 'ImageUrlModal'
	| 'EditProjectPlan'
	| 'EditProjectPlanType'
	| 'CreateRelation'
	| 'SubaccountDrawer'
	| 'IndustryInsightsDrawer'
	| 'TemplateEditorModal'
	| 'AgreementFulfillmentModal'
	| 'LostOpportunityModal'
	| 'MergeClients'
	| 'ConfirmParentProspecting'
	| 'DelayedPayment'
	| 'UpdateClientDuns'
	| 'ListModal'
	| 'OptIn'
	| 'ConfirmBuyProspectsModal'
	| 'SelectOpportunity'
	| 'DownloadList'
	| 'UploadFileModal'
	| 'SelectFieldModal'
	| 'EditNote'
	| 'MoveOrCloseActivity'
	| 'CreateGroupMail'
	| 'StageListModal'
	| 'CreateDocumentModal'
	| 'PdfGeneric'
	| 'PreviewPdfModal'
	| 'ConfirmEsignModal'
	| 'AccountRelationModal'
	| 'NextStepModal'
	| 'TranslateFieldsModal'
	| 'CreateMailTemplate'
	| 'AssignModalLead'
	| 'FileBrowserModal'
	| 'CreateActivityModal'
	| 'OptOutModal'
	| 'WonOpportunityModal'
	| 'SalesCoachModal'
	| 'YourYearWithUpsalesModal'
	| 'InsertTag'
	| 'LandingPageSettings'
	| 'EditAppointment'
	| 'ClientListModal'
	| 'DecisionMakersModal'
	| 'VerifyBudgetModal'
	| 'EditEventDomainModal'
	| 'AddProductModal'
	| 'SharedViewsModal'
	| 'SolutionModal'
	| 'OpenCall'
	| 'CreateReportModal'
	| 'MailTemplateBrowserModal'
	| 'MultiUpdateContact'
	| 'MultiUpdateOrder'
	| 'MultiUpdateTicket'
	| 'MultiUpdateProjectPlan'
	| 'EditCustomFieldModal'
	| 'EditPromptModal'
	| 'IntegrationModal'
	| 'EditRoleModal'
	| 'GenericModal'
	| 'ConfirmSoliditetBuyParentModal'
	| 'ConfirmLandingPageModal'
	| 'ResetLeadMulti'
	| 'EditEsign'
	| 'ResetScore'
	| 'AppWidgetModal'
	| 'MultiUpdateAppointmentModal'
	| 'EditCampaign'
	| 'EditStandardFieldModal'
	| 'Map'
	| 'ProjectMap'
	| 'CustomerPortfolioPotentialDrawer'
	| 'ExportContactData'
	| 'ValidDomainModal'
	| 'EditDocumentTemplateModal'
	| 'ConfirmSoliditetUpdateModal'
	| 'ScrapeCompanyWebsites'
	| 'NewSegmentModal'
	| 'ChecklistItemModal'
	| 'CreateActivityAction'
	| 'SendEmailAction'
	| 'DecisionMakersProModal'
	| 'LandingpageEditorModal'
	| 'RelationsSignalDrawer'
	| 'MergeTickets'
	| 'RequestTierUpgradeModal'
	| 'CdhTableRowDrawer'
	| 'DocumentTemplateCopyModal';

export type ModalConfig = {
	component: LazyExoticComponent<any> | FunctionComponent<any> | typeof Component;
	opts?: ModalOpts;
	props?: { [key: string]: any; onClose?: (data?: any) => void };
};

const configs = {
	LeadDrawer: {
		component: LeadDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	ApiKey: {
		component: ApiKey,
		opts: { animation: Animation.SlideBottom }
	},
	VisitDrawer: {
		component: VisitDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	ForecastingDrawer: {
		component: ForecastingDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	EditPhonecall: {
		component: EditPhonecall,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	EditCallList: {
		component: EditCallListDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	ExportDataReact: {
		component: ExportDataReact,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	EditColumnsModal: {
		component: EditColumnsModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	EditGuestListColumnsModal: {
		component: EditGuestListColumnsModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateActivity: {
		component: MultiUpdateActivity,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateClient: {
		component: MultiUpdateClient,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	MultiCloseActivityModal: {
		component: MultiCloseActivityModal,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	EditTodo: { component: EditTodo, opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true } },
	CreateTodo: {
		component: CreateTodo,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	CreateCall: {
		component: CreateCall,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	CreateTodosAction: {
		component: CreateTodosAction,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	FormActionCondition: {
		component: FormActionCondition,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	PlanPhonecallsAction: {
		component: PlanPhonecallsAction,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	PlanPhonecallsMulti: {
		component: PlanPhonecallsMulti,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	CreateTodosMulti: {
		component: CreateTodosMulti,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	AdditionalBoardMembers: {
		component: AdditionalBoardMembers,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	UtmLinkGenerator: {
		component: UtmLinkGenerator,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	NotificationDetail: {
		component: NotificationDetailModal,
		opts: { animation: Animation.Fade }
	},
	ContactScraperModal: {
		component: ContactScraperModal,
		opts: { animation: Animation.Fade, closeOnEscape: true, closeOnCurtain: true }
	},
	ContactScraperConfirmModal: {
		component: ContactScraperConfirmModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true, closeOnCurtain: true }
	},
	AddSocialEventContacts: {
		component: EditSocialEventAddContacts,
		opts: { animation: Animation.Fade },
		props: { modal: true }
	},
	GoalSummaryDrawer: {
		component: GoalSummaryDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	NotificationDropdown: {
		component: NotificationDropdown,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	PlanPhonecallsTriggerAction: {
		component: PlanPhonecallsTriggerAction,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	CreateTodoTriggerAction: {
		component: CreateTodoTriggerAction,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	ReportcenterDrilldownDrawer: {
		component: ReportcenterDrilldownDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	ListDrawer: {
		component: ListDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	MergeWithBoardmemberModal: {
		component: MergeWithBoardmemberModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	CompetitorDrawer: {
		component: CompetitorDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	SignalsNews: {
		component: SignalsNews,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	RisksCompanyGroup: {
		component: RisksCompanyGroup,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	UpsellCompanyGroup: {
		component: UpsellCompanyGroup,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	SessionExpireWarning: {
		component: SessionExpireWarning,
		opts: {
			animation: Animation.Fade
		}
	},
	EditClient: {
		component: EditClient,
		opts: {
			animation: Animation.SlideBottom,
			closeOnEscape: true
		}
	},
	EditContact: {
		component: EditContact,
		opts: {
			animation: Animation.SlideBottom,
			closeOnEscape: true
		}
	},
	AccountDeactivationModal: {
		component: AccountDeactivationModal,
		opts: {
			animation: Animation.Fade
		}
	},
	AssignModal: {
		component: AssignModalReact,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	SentMail: {
		component: SentMail,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	NewSingleMail: {
		component: NewSingleMail,
		opts: { drawer: true, animation: Animation.DrawerRight }
	},
	ChooseMailIntegration: {
		component: ChooseMailIntegrationModal,
		opts: { animation: Animation.Fade }
	},
	AddLabelsMulti: {
		component: AddLabelsMulti,
		opts: { animation: Animation.Fade }
	},
	AcceptTerms: {
		component: AcceptTerms,
		opts: { animation: Animation.SlideBottom, closeOnCurtain: false }
	},
	RequestSupport: {
		component: RequestSupport,
		opts: { animation: Animation.SlideBottom, closeOnCurtain: false }
	},
	SendWebhook: {
		component: SendWebhook,
		opts: {
			animation: Animation.SlideBottom,
			closeOnCurtain: true,
			closeOnEscape: true
		}
	},
	CreateFlow: {
		component: CreateFlow,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	CreateForm: {
		component: CreateFormReact,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	CreateTemplateFlow: {
		component: CreateTemplateFlow,
		opts: {
			animation: Animation.Fade
		}
	},
	EditDynamicLink: {
		component: EditDynamicLink,
		opts: {
			closeOnCurtain: true,
			closeOnEscape: true,
			animation: Animation.SlideBottom
		}
	},
	SubscriptionPreview: {
		component: SubscriptionPreview,
		opts: {
			animation: Animation.SlideBottom,
			closeOnCurtain: true
		}
	},
	CreateSubscription: {
		component: CreateSubscription,
		opts: {
			animation: Animation.Fade
		}
	},
	EditSubscription: {
		component: EditSubscription,
		opts: {
			animation: Animation.Fade
		}
	},
	MoveSubscription: {
		component: MoveSubscription,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	FlowLoopSettings: {
		component: FlowLoopSettings,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	WonOpportunityWithSubs: {
		component: WonOpportunityWithSubs,
		opts: {
			animation: Animation.Fade
		}
	},
	DeleteForbiddenAlert: {
		component: DeleteForbiddenAlert,
		opts: {
			animation: Animation.Fade
		}
	},
	EditProductCategory: {
		component: EditProductCategory,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	CleanMyData: {
		component: CleanMyData,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	HandleDuplicates: {
		component: HandleDuplicates,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	MailPreview: {
		component: MailPreview,
		opts: {
			animation: Animation.Fade
		}
	},
	MaxCeilingReachedOnSeats: {
		component: MaxCeilingReachedOnSeatsReact,
		opts: {}
	},
	PriceListDrawer: {
		component: PriceListDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight }
	},
	ProductBundleDrawer: {
		component: ProductBundleDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	CreateAccount: {
		component: CreateAccount,
		opts: {
			animation: Animation.SlideBottom,
			closeOnEscape: true
		}
	},
	EditProductBundleOrder: {
		component: EditProductBundleOrder
	},
	NewMarketEvent: {
		component: NewMarketEvent,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	EditClientTarget: {
		component: EditClientTarget,
		opts: {
			drawer: true,
			closeOnCurtain: true,
			animation: Animation.DrawerRight
		}
	},
	ARRChangeDrawerV2: {
		component: ARRChangeDrawerV2,
		opts: {
			drawer: true,
			closeOnCurtain: true,
			animation: Animation.DrawerRight
		}
	},
	ProductSearch: {
		component: ProductSearch,
		opts: {}
	},
	EditTicket: {
		component: OpenTicket,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	CreateExternalContact: {
		component: CreateExternalContact,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	ForwardConversation: {
		component: ForwardConversation,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	CopySocialEvent: {
		component: CopySocialEvent,
		opts: {}
	},
	ReportcenterTV: {
		component: ReportcenterTV
	},
	FindSocialEvent: {
		component: FindSocialEventModal,
		opts: {}
	},
	FindClient: {
		component: FindClientModal,
		opts: {}
	},
	FindForm: {
		component: FindFormModal,
		opts: {}
	},
	EditFormSubmit: {
		component: EditFormSubmitModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	FindContact: {
		component: FindContactModal,
		opts: {}
	},
	MoveContact: {
		component: MoveContactModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	ReportcenterTVSettings: {
		component: ReportcenterTVSettings,
		opts: {
			drawer: true,
			animation: Animation.DrawerRight,
			closeOnCurtain: true
		}
	},
	ReportcenterTVPublicDisplayConnect: {
		component: ReportcenterTVPublicDisplayConnect,
		opts: {
			closeOnCurtain: true
		}
	},
	Alert: {
		component: Alert,
		opts: {
			closeOnEscape: true
		}
	},
	UnsavedChangesAlert: {
		component: UnsavedChangesAlert,
		opts: {
			closeOnEscape: true
		}
	},
	SaveChangesAlert: {
		component: SaveChangesAlert,
		opts: {
			closeOnEscape: true
		}
	},
	RemoveAlert: {
		component: RemoveAlert,
		opts: {
			closeOnEscape: true
		}
	},
	AskForInput: {
		component: AskForInput,
		opts: {
			closeOnEscape: true
		}
	},
	MatchCompaniesBeforeMerge: {
		component: MatchCompaniesBeforeMerge,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	DuplicateIntroModal: {
		component: DuplicateIntroModal,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	ToggleFiscalYear: {
		component: ToggleFiscalYearModalReact,
		opts: {
			animation: Animation.SlideBottom,
			closeOnEscape: true,
			closeOnCurtain: true
		}
	},
	InactivateContacts: {
		component: InactivateContacts,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	EditMailSignature: {
		component: EditMailSignatureRoot,
		opts: {}
	},
	MergeContacts: {
		component: MergeContacts,
		opts: { closeOnEscape: true }
	},
	CreateUpsalesAccount: {
		component: CreateUpsalesAccount,
		opts: {}
	},
	CreateAppointmentAction: {
		component: CreateAppointmentAction,
		opts: { closeOnEscape: true }
	},
	RefreshAccount: {
		component: RefreshAccount,
		opts: {}
	},
	EditSocialEventAddResource: {
		component: EditSocialEventAddResource,
		opts: {}
	},
	FullTerms: {
		component: FullTermsModal,
		opts: {}
	},
	RiskDrawer: {
		component: RiskDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	AnonFieldPage: {
		component: AnonFieldPage,
		opts: {}
	},
	EditOrder: {
		component: EditOrder,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	ViewTickets: {
		component: ViewTickets,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true }
	},
	VerifyTimeframeModal: {
		component: VerifyTimeframeModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	EditTicketResponseTemplate: {
		component: EditTicketResponseTemplate,
		opts: { animation: Animation.SlideBottom }
	},
	EditTicketAutoReplyTemplate: {
		component: EditTicketAutoReplyTemplate,
		opts: { animation: Animation.SlideBottom }
	},
	EditProjectPlanTemplate: {
		component: EditProjectPlanTemplate,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	EditTaskTemplate: {
		component: EditTaskTemplate,
		opts: {
			animation: Animation.SlideBottom
		}
	},
	ImageUrlModal: {
		component: ImageUrlModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	EditProjectPlan: {
		component: EditProjectPlan,
		opts: { drawer: true, closeOnCurtain: true, animation: Animation.DrawerRight, closeOnEscape: true }
	},
	EditProjectPlanType: {
		component: EditProjectPlanType,
		opts: { animation: Animation.SlideBottom }
	},
	CreateRelation: {
		component: CreateRelation,
		opts: { drawer: true, closeOnCurtain: true, closeOnEscape: true, animation: Animation.DrawerRight }
	},
	SubaccountDrawer: {
		component: SubaccountDrawer,
		opts: { drawer: true, closeOnCurtain: true, animation: Animation.DrawerRight }
	},
	IndustryInsightsDrawer: {
		component: IndustryInsightsDrawer,
		opts: { drawer: true, closeOnEscape: true, closeOnCurtain: true, animation: Animation.DrawerRight }
	},
	AgreementFulfillmentModal: {
		component: AgreementFulfillmentModal,
		opts: {}
	},
	ConfirmBuyProspectModal: {
		component: ConfirmBuyProspectModal,
		opts: {
			closeOnEscape: true,
			closeOnCurtain: true
		}
	},
	LostOpportunityModal: {
		component: LostOpportunityModal,
		opts: {}
	},
	EditNote: {
		component: EditNote,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	ListModal: {
		component: ListModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	UploadFileModal: {
		component: UploadFileModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	AddToSegmentModal: {
		component: AddToSegmentModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	SelectFieldModal: {
		component: SelectFieldModal,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	MoveOrCloseActivity: {
		component: MoveOrCloseActivity,
		opts: { closeOnEscape: true }
	},
	ConfirmBuyProspectsModal: {
		component: ConfirmBuyProspectsModal,
		opts: {
			closeOnEscape: true,
			closeOnCurtain: true
		}
	},
	TemplateEditorModal: {
		component: TemplateEditorModal,
		opts: {}
	},
	EditUDO: {
		component: EditUDOModal,
		opts: { closeOnEscape: true }
	},
	CreateGroupMail: {
		component: CreateGroupMail,
		opts: { closeOnEscape: true }
	},
	StageListModal: {
		component: StageListModal,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	CreateDocumentModal: {
		component: CreateDocumentModal,
		opts: {}
	},
	PdfGeneric: {
		component: PdfGeneric,
		opts: {}
	},
	PreviewPdfModal: {
		component: PreviewPdfModal as any,
		opts: { closeOnEscape: true, animation: Animation.SlideBottom }
	},
	ConfirmEsignModal: {
		component: ConfirmEsignModal,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	AccountRelationModal: {
		component: AccountRelationModal,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	AssignModalLead: {
		component: AssignModalLead,
		opts: { closeOnCurtain: false, closeOnEscape: true }
	},
	CreateActivityModal: {
		component: CreateActivityModal,
		opts: {}
	},
	OptOutModal: {
		component: OptOutModal as React.ComponentType<{ id?: number; close: () => void; className?: string }>,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	WonOpportunityModal: {
		component: WonOpportunityModal,
		opts: { closeOnEscape: false }
	},
	YourYearWithUpsalesModal: {
		component: YourYearWithUpsalesModal,
		opts: { animation: Animation.SlideBottom, closeOnCurtain: false, closeOnEscape: false }
	},
	InsertTag: {
		component: InsertTag,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	LandingPageSettings: {
		component: LandingPageSettings,
		opts: { closeOnEscape: true }
	},
	EditAppointment: {
		component: EditAppointment,
		opts: { closeOnEscape: true }
	},
	FileBrowserModal: {
		component: FileBrowserModal,
		opts: {}
	},
	SalesCoachModal: {
		component: SalesCoachModalReact,
		opts: { closeOnCurtain: true }
	},
	CreateReportModal: {
		component: CreateReportModal,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnEscape: true }
	},
	EditEventDomainModal: {
		component: EditEventDomainModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	AddProductModal: {
		component: EditProductModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	OpenCall: {
		component: OpenCallModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	RequestTierUpgradeModal: {
		component: RequestTierUpgradeModal,
		opts: {}
	},
	EditCustomFieldModal: {
		component: EditCustomFieldModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	EditPromptModal: {
		component: EditPromptModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	OptIn: {
		component: OptIn,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	ClientListModal: {
		component: ClientListModal,
		opts: {
			closeOnEscape: true,
			closeOnCurtain: true
		}
	},
	SharedViewsModal: {
		component: SharedViewsModal,
		opts: { closeOnEscape: true, closeOnCurtain: false }
	},
	IntegrationModal: {
		component: IntegrationModal,
		opts: {
			closeOnCurtain: false,
			closeOnEscape: false
		}
	},
	VerifyBudgetModal: {
		component: VerifyBudgetModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	GenericModal: {
		component: GenericModal,
		opts: { closeOnEscape: true }
	},
	ConfirmLandingPageModal: {
		component: ConfirmLandingPageModal,
		opts: {
			closeOnEscape: true
		}
	},
	SolutionModal: {
		component: SolutionModal,
		opts: { animation: Animation.SlideBottom }
	},
	MailTemplateBrowserModal: {
		component: MailTemplateBrowserModal,
		opts: { closeOnEscape: true }
	},
	EditRoleModal: {
		component: EditRoleModal,
		opts: { animation: Animation.SlideBottom }
	},
	AppWidgetModal: {
		component: AppWidget,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateContact: {
		component: MultiUpdateContact,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateOrder: {
		component: MultiUpdateOrder,
		opts: { drawer: false, animation: Animation.SlideBottom, closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateTicket: {
		component: MultiUpdateTicket,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateProjectPlan: {
		component: MultiUpdateProjectPlan,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	MultiUpdateAppointmentModal: {
		component: MultiUpdateAppointmentModal,
		opts: { closeOnEscape: true }
	},
	CreateActivityAction: {
		component: CreateActivityActionModal,
		opts: { closeOnEscape: true }
	},
	SelectOpportunity: {
		component: SelectOpportunity,
		opts: { closeOnCurtain: true, closeOnEscape: true }
	},
	DelayedPayment: {
		component: DelayedPayment,
		opts: { closeOnCurtain: false, closeOnEscape: false }
	},
	ResetScore: {
		component: ResetScore,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	EditStandardFieldModal: {
		component: EditStandardFieldModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true, closeOnCurtain: true }
	},
	UpdateClientDuns: {
		component: UpdateClientDuns,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	MergeClients: {
		component: MergeClients,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	Map: {
		component: Map,
		opts: { closeOnEscape: true }
	},
	ProjectMap: {
		component: ProjectMap,
		opts: { closeOnEscape: true }
	},
	EditCampaign: {
		component: EditCampaignModal,
		opts: { closeOnEscape: true }
	},
	CustomerPortfolioPotentialDrawer: {
		component: CustomerPortfolioPotentialDrawer,
		opts: { drawer: true, closeOnCurtain: true, closeOnEscape: true, animation: Animation.DrawerRight }
	},
	ExportContactData: {
		component: ExportContactDataModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	ValidDomainModal: {
		component: ValidDomainModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	EditDocumentTemplateModal: {
		component: EditDocumentTemplateModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	ConfirmSoliditetUpdateModal: {
		component: ConfirmSoliditetUpdateModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	DownloadList: {
		component: DownloadList,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	TranslateFieldsModal: {
		component: TranslateFieldsModal,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	NewSegmentModal: {
		component: NewSegmentModal,
		opts: { closeOnEscape: true, animation: Animation.SlideBottom }
	},
	SendEmailAction: {
		component: SendEmailAction,
		opts: { closeOnEscape: true, closeOnCurtain: true, animation: Animation.SlideBottom }
	},
	ConfirmParentProspecting: {
		component: ConfirmParentProspecting,
		opts: { closeOnEscape: true }
	},
	NextStepModal: {
		component: NextStepModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	ChecklistItemModal: {
		component: ChecklistItemModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	DecisionMakersModal: {
		component: DecisionMakersModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	DecisionMakersProModal: {
		component: DecisionMakersProModal,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	ConfirmSoliditetBuyParentModal: {
		component: ConfirmSoliditetBuyParentModal,
		opts: { closeOnEscape: true }
	},
	CreateMailTemplate: {
		component: CreateMailTemplateModal,
		opts: { closeOnEscape: true }
	},
	EditEsign: {
		component: EditEsign,
		opts: {}
	},
	LandingpageEditorModal: {
		component: LandingpageEditorModal,
		opts: {}
	},
	ResetLeadMulti: {
		component: ResetLeadMulti,
		opts: { closeOnEscape: true, closeOnCurtain: true }
	},
	RelationsSignalDrawer: {
		component: RelationsSignalDrawer,
		opts: { drawer: true, closeOnCurtain: true, closeOnEscape: true, animation: Animation.DrawerRight }
	},
	MergeTickets: {
		component: MergeTickets,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true }
	},
	ScrapeCompanyWebsites: {
		component: ScrapeCompanyWebsites,
		opts: { animation: Animation.SlideBottom, closeOnEscape: true, closeOnCurtain: true }
	},
	CdhTableRowDrawer: {
		component: CdhTableRowDrawer,
		opts: { drawer: true, animation: Animation.DrawerRight, closeOnCurtain: true, closeOnEscape: true }
	},
	DocumentTemplateCopyModal: {
		component: DocumentTemplateCopyModal,
		opts: {
			closeOnEscape: true,
			closeOnCurtain: true
		}
	}
} satisfies Record<ModalConfigName, ModalConfig>;

export type ModalConfigByName<Conf extends ModalConfigName> = (typeof configs)[Conf];
export type ModalComponentProps<Conf extends ModalConfigName> = Collect<
	ComponentProps<ModalConfigByName<Conf>['component']>
>;

export default configs;
